import apiClient from './client';

// ===== REFERRERS =====

/**
 * Get all referrers with filters and pagination
 */
export const getReferrers = async (params = {}) => {
    const response = await apiClient.get('/referrers', { params });
    return response.data;
};

/**
 * Get single referrer by ID
 */
export const getReferrerById = async (id) => {
    const response = await apiClient.get(`/referrers/${id}`);
    return response.data;
};

/**
 * Create new referrer
 */
export const createReferrer = async (data) => {
    const response = await apiClient.post('/referrers', data);
    return response.data;
};

/**
 * Update referrer
 */
export const updateReferrer = async (id, data) => {
    const response = await apiClient.put(`/referrers/${id}`, data);
    return response.data;
};

/**
 * Delete referrer (soft delete)
 */
export const deleteReferrer = async (id) => {
    const response = await apiClient.delete(`/referrers/${id}`);
    return response.data;
};

/**
 * Get referrer statistics
 */
export const getReferrerStatistics = async () => {
    const response = await apiClient.get('/referrers/statistics');
    return response.data;
};

/**
 * Get referrers with unpaid commission
 */
export const getReferrersWithUnpaidCommission = async () => {
    const response = await apiClient.get('/referrers/unpaid-commission');
    return response.data;
};

/**
 * Get customers referred by a referrer
 */
export const getReferrerCustomers = async (id) => {
    const response = await apiClient.get(`/referrers/${id}/customers`);
    return response.data;
};

/**
 * Record commission payment
 */
export const recordCommissionPayment = async (id, paymentData) => {
    const response = await apiClient.post(`/referrers/${id}/payments`, paymentData);
    return response.data;
};

/**
 * Get payment history for a referrer
 */
export const getPaymentHistory = async (id) => {
    const response = await apiClient.get(`/referrers/${id}/payments`);
    return response.data;
};

/**
 * Generate referrer commission statement PDF
 */
export const generateReferrerStatement = async (id, startDate, endDate) => {
    const response = await apiClient.get(`/referrers/${id}/statement`, {
        params: { startDate, endDate },
        responseType: 'blob' // Important for file download
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `referrer-statement-${id}-${startDate}-${endDate}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);

    return response.data;
};

/**
 * Get referrer commission trend data
 */
export const getReferrerCommissionTrend = async (id) => {
    const response = await apiClient.get(`/referrers/${id}/commission-trend`);
    return response.data;
};

/**
 * Check for duplicate referrers
 */
export const checkDuplicates = async (fullName, phone, excludeId = null) => {
    const params = {};
    if (fullName) params.fullName = fullName;
    if (phone) params.phone = phone;
    if (excludeId) params.excludeId = excludeId;

    const response = await apiClient.get('/referrers/check-duplicates', { params });
    return response.data;
};

export default {
    getReferrers,
    getReferrerById,
    createReferrer,
    updateReferrer,
    deleteReferrer,
    getReferrerStatistics,
    getReferrersWithUnpaidCommission,
    getReferrerCustomers,
    recordCommissionPayment,
    getPaymentHistory,
    generateReferrerStatement,
    getReferrerCommissionTrend,
    checkDuplicates
};
